var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKey = function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27891 9.59609C7.01023 8.92756 6.87309 8.21346 6.875 7.49297C6.875 4.4789 9.30312 1.97422 12.3156 1.87812C13.0852 1.85247 13.8518 1.98509 14.568 2.26776C15.2843 2.55043 15.9348 2.97714 16.4794 3.52145C17.024 4.06577 17.4511 4.7161 17.7342 5.43217C18.0172 6.14824 18.1502 6.9148 18.125 7.68437C18.0258 10.6969 15.5211 13.125 12.507 13.125C11.7865 13.1269 11.0724 12.9898 10.4039 12.7211L9.375 13.75H7.5V15.625H5.625V17.5H3.125C2.95924 17.5 2.80027 17.4342 2.68306 17.3169C2.56585 17.1997 2.5 17.0408 2.5 16.875V14.6336C2.50008 14.4681 2.56582 14.3093 2.68281 14.1922L7.27891 9.59609Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 6.875C14.5803 6.875 15 6.45527 15 5.9375C15 5.41973 14.5803 5 14.0625 5C13.5447 5 13.125 5.41973 13.125 5.9375C13.125 6.45527 13.5447 6.875 14.0625 6.875Z",
    fill: "#919191"
  })));
};
export default SvgKey;